/**
 * @file useInView.ts
 * @description Элемент хоть раз показался на экране (`IntersectionObserver`):
 * образцы шрифтов грузят файл, только когда видны (phase19.16 Р1, uiux-design-r1
 * §11 риск 2; подсказка о шрифте элемента — uiux-fonts-usage §9 вопрос 6).
 * Без `IntersectionObserver` (старый браузер, тесты) — сразу «виден».
 */

import { useEffect, useRef, useState, type RefObject } from "react";

export function useInView<T extends Element>(): { ref: RefObject<T | null>; visible: boolean } {
  const ref = useRef<T | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) {
        setVisible(true);
        observer.disconnect();
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return { ref, visible };
}
